import React, {useEffect} from 'react';
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";

import {ReactComponent as LogoImage} from "../../images/logo.svg";
import {ReactComponent as TwoGisMapsSmallImage} from "../../images/2gis-maps-small.svg";
import {ReactComponent as YandexMapsSmallImage} from "../../images/yandex-maps-small.svg";
import {ReactComponent as MapsSmallImage} from "../../images/maps-small.svg";
import {ReactComponent as VkIcon} from "../../images/icons/vk.svg";
import {ReactComponent as TelegramIcon} from "../../images/icons/telegram.svg";
import {ReactComponent as PhoneIcon} from "../../images/icons/phone.svg";
import {ReactComponent as WorkTimeIcon} from "../../images/icons/work-time.svg";
import {ReactComponent as LinesMobileHeaderIcon} from "../../images/icons/lines-mobile-header.svg";
import {ReactComponent as CloseIcon} from "../../images/icons/close.svg";
import Button from "../../components/ui/button/button";
import ModalComponent from "../../components/ui/modalComponent/modalComponent";
import Checkbox from "../../components/ui/checkbox/checkbox";
import API from "../../components/api";
import {SERVER_URL} from "../../config";


export function withRouter(Component) {
    return function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params}
            />
        );
    };
}

export function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [pathname]);

    return null;
}

class MainLayout extends React.Component {
    constructor(props) {
        super(props);

        this.myRef = React.createRef();

        this.renderNavigation = this.renderNavigation.bind(this);

        this.state = {
            headerStatus: false,

            isCallModalOpen: false,

            docs: []
        }

        this.openCallModal = () => {
            this.setState({isCallModalOpen: true})
        }

        this.sendCall = () => {
            API.postRequestCall(this.state.name, this.state.phone)
                .then(data => {
                    this.props.addSnackbar("Спасибо, мы перезвоним вам в ближайшее время", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.setState({isCallModalOpen: false})
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось отправить заявку", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.changeMobileHeaderStatus = () => {
            let headerStatus = !this.state.headerStatus;

            const node = this.myRef.current;
            if (headerStatus) {
                document.getElementsByClassName('mobile-header-open')[0].classList.add('active')
                // node.classList.add('hidden');
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden'; // iOS fix
            } else {
                document.getElementsByClassName('mobile-header-open')[0].classList.remove('active')
                // node.classList.remove('hidden');
                document.body.style.overflow = '';
                document.documentElement.style.overflow = '';
            }

            this.setState({headerStatus: headerStatus})
        }
    }

    componentDidMount() {
        API.getDocsShort()
            .then(data => this.setState({docs: data}))
            .catch(e => {
            })
    }

    renderNavigation(callback) {
        const {pathname} = this.props.location;

        const isActive = (path) => {
            return pathname === path || pathname.startsWith(path);
        };

        const getClass = (path) =>
            `button item action_16_24 ${isActive(path) ? "active" : ""}`;

        return (
            <div className="navigation">
                <Link className={getClass("/services")} to="/services/"
                      onClick={callback}>
                    Все услуги
                </Link>

                <Link className={getClass("/about")} to="/about/"
                      onClick={callback}>
                    О нас
                </Link>

                <Link className={getClass("/contacts")} to="/contacts/"
                      onClick={callback}>
                    Контакты
                </Link>

                <Link className={getClass("/faq")} to="/faq/"
                      onClick={callback}>
                    Частые вопросы
                </Link>

                <Link className={getClass("/employees")} to="/employees/"
                      onClick={callback}>
                    Сотрудники и вакансии
                </Link>

                <Link className={getClass("/articles")} to="/articles/"
                      onClick={callback}>
                    Статьи
                </Link>

                <Link className={getClass("/docs")} to="/docs/"
                      onClick={callback}>
                    Документы
                </Link>
            </div>
        );
    }

    render() {
        return <div className='root'>
            <ScrollToTop/>
            <div className='main'>
                <div className='header'>
                    <div className='top'>
                        <Link to='/'>
                            <LogoImage/>
                        </Link>
                        <div className='address-container'>
                            <div className='maps-container'>
                                <div className='list'>
                                    <a href='https://yandex.com/maps/org/estei/1699146815/reviews/?ll=73.309824%2C54.983035&z=15'
                                       target='_blank'>
                                        <YandexMapsSmallImage/>
                                    </a>
                                    <a href='https://2gis.ru/omsk/firm/70000001018401753/tab/reviews' target='_blank'>
                                        <TwoGisMapsSmallImage/>
                                    </a>
                                </div>
                                <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                                   target='_blank'>
                                    <MapsSmallImage/>
                                </a>
                            </div>
                            <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                               target='_blank' className='headline_16_20'>
                                Омск, пр-т Комарова 21 к2,
                                <br/>помещение 2П
                            </a>
                        </div>
                        <div className='social-media-container'>
                            {/*<a className='item button' href='#'>*/}
                            {/*    <WhatsappIcon/>*/}
                            {/*</a>*/}
                            <a className='item button' href='https://t.me/esteistom' target='_blank'>
                                <TelegramIcon/>
                            </a>
                            <a className='item button' href='https://vk.com/estei' target='_blank'>
                                <VkIcon/>
                            </a>
                        </div>
                        <div className='contacts-container'>
                            <div className='contacts-info'>
                                <PhoneIcon/>
                                <div className='phone-numbers'>
                                    <a className='headline_18_22 button' href='tel:+79059225522'>
                                        +7 905 922 55 22
                                    </a>
                                    <a className='paragraph_14_20 button' href='tel:+7(3812)956010'>
                                        или +7 (3812) 95 60 10
                                    </a>
                                </div>
                            </div>
                            <div className='button' onClick={this.openCallModal}>
                                Заказать звонок
                            </div>
                        </div>
                    </div>
                    <div className='bottom'>
                        <div className='button action_16_24'>
                            <WorkTimeIcon/>
                            Режим работы
                            <div className='time-work'>
                                <div className='block-1'>
                                    <div className='label-1'>
                                        ПН - ПТ
                                    </div>
                                    <div className='label-2'>
                                        с 9 до 19
                                    </div>
                                </div>
                                <div className='block-2'>
                                    <div className='label-1'>
                                        СБ
                                    </div>
                                    <div className='label-2'>
                                        с 9 до 14
                                    </div>
                                </div>
                                <div className='block-3'>
                                    <div className='label-1'>
                                        ВС
                                    </div>
                                    <div className='label-2'>
                                        Выходной
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.renderNavigation()}
                    </div>
                </div>
                <div className='header-mobile'>
                    <div className='top'>
                        <Link to='/'>
                            <LogoImage/>
                        </Link>
                        <div className='button' onClick={this.changeMobileHeaderStatus}>
                            <LinesMobileHeaderIcon/>
                            Меню
                        </div>
                    </div>
                </div>
                <div className='mobile-header-open'>
                    <div className='top'>
                        <Link to='/' onClick={this.changeMobileHeaderStatus}>
                            <LogoImage/>
                        </Link>
                        <div className='button' onClick={this.changeMobileHeaderStatus}>
                            <CloseIcon/>
                            Закрыть
                        </div>
                    </div>
                    {this.renderNavigation(this.changeMobileHeaderStatus)}
                    <div className='header'>
                        <div className='top'>
                            <div className='address-container'>
                                <div className='maps-container'>
                                    <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                                       target='_blank'>
                                        <MapsSmallImage/>
                                    </a>
                                </div>
                                <a href='https://2gis.ru/omsk/firm/70000001018401753?m=73.30783%2C54.982885%2F18.68'
                                   target='_blank' className='headline_16_20'>
                                    Омск, пр-т Комарова 21 к2,
                                    <br/>помещение 2П
                                </a>
                            </div>
                            <div className='contacts-container'>
                                <div className='contacts-info'>
                                    <PhoneIcon/>
                                    <div className='phone-numbers'>
                                        <a className='headline_18_22 button' href='tel:+79059225522'>
                                            +7 905 922 55 22
                                        </a>
                                        <a className='paragraph_14_20 button' href='tel:+7(3812)956010'>
                                            или +7 (3812) 95 60 10
                                        </a>
                                    </div>
                                </div>
                                <div className='button' onClick={this.openCallModal}>
                                    Заказать звонок
                                </div>
                            </div>
                            <div className='list'>
                                <a href='https://yandex.com/maps/org/estei/1699146815/reviews/?ll=73.309824%2C54.983035&z=15'
                                   target='_blank'>
                                    <YandexMapsSmallImage/>
                                </a>
                                <a href='https://2gis.ru/omsk/firm/70000001018401753/tab/reviews' target='_blank'>
                                    <TwoGisMapsSmallImage/>
                                </a>
                            </div>
                            <div className='time-work-container'>
                                Режим работы
                                <div className='time-work'>
                                    <div className='block-1'>
                                        <div className='label-1'>
                                            ПН - ПТ
                                        </div>
                                        <div className='label-2'>
                                            с 9 до 19
                                        </div>
                                    </div>
                                    <div className='block-2'>
                                        <div className='label-1'>
                                            СБ
                                        </div>
                                        <div className='label-2'>
                                            с 9 до 14
                                        </div>
                                    </div>
                                    <div className='block-3'>
                                        <div className='label-1'>
                                            ВС
                                        </div>
                                        <div className='label-2'>
                                            Выходной
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='content' ref={this.myRef}>
                    <Outlet openCallModal={this.openCallModal}/>
                    <div className='footer'>
                        <div className='top'>
                            {
                                this.state.docs
                                    .slice(0, 6)                 // максимум 6 документов (3 блока по 2)
                                    .reduce((acc, doc, index) => {
                                        if (index % 2 === 0) {
                                            acc.push([doc]);
                                        } else {
                                            acc[acc.length - 1].push(doc);
                                        }
                                        return acc;
                                    }, [])
                                    .map((pair, i) => (
                                        <div className='block' key={i}>
                                            {pair.map((doc, j) => (
                                                <a
                                                    key={j}
                                                    className='action_16_24'
                                                    href={SERVER_URL + doc.document_url}
                                                    target='_blank'
                                                >
                                                    {doc.name}
                                                </a>
                                            ))}
                                        </div>
                                    ))
                            }
                            <div className='contacts-container'>
                                <div className='contacts-info'>
                                    <PhoneIcon/>
                                    <div className='phone-numbers'>
                                        <a className='headline_18_22 button' href='tel:+79059225522'>
                                            +7 905 922 55 22
                                        </a>
                                        <a className='paragraph_14_20 button' href='tel:+7(3812)956010'>
                                            или +7 (3812) 95 60 10
                                        </a>
                                    </div>
                                </div>
                                <div className='button' onClick={this.openCallModal}>
                                    Заказать звонок
                                </div>
                            </div>
                        </div>
                        <div className='navigation'>
                            {this.renderNavigation()}
                            <div className='social-media-container'>
                                {/*<a className='item button' href='#'>*/}
                                {/*    <WhatsappIcon/>*/}
                                {/*</a>*/}
                                <a className='item button' href='https://t.me/esteistom' target='_blank'>
                                    <TelegramIcon/>
                                </a>
                                <a className='item button' href='https://vk.com/estei'>
                                    <VkIcon/>
                                </a>
                            </div>
                        </div>
                        <div className='bottom'>
                            <div className='year'>
                                работаем с 2015 года
                            </div>
                            <div className='company'>
                                ООО «ЭСТЭЙ»
                            </div>
                        </div>
                    </div>
                </div>
                <ModalComponent customClass="call-modal"
                                isOpen={this.state.isCallModalOpen}
                                onClose={() => this.setState({isCallModalOpen: false})}>
                    <div className='call-modal-entry'>
                        <div className='title'>
                            Перезвоним вам в&nbsp;течение дня
                        </div>
                        <div className='inputs'>
                            <input placeholder='Ваше имя' value={this.state.name}
                                   onChange={(e) => this.setState({name: e.target.value})}/>
                            <input placeholder='Номер телефона' value={this.state.phone}
                                   onChange={(e) => this.setState({phone: e.target.value})}/>
                        </div>
                        <div className='consent'>
                            <Checkbox
                                checked={this.state.isChecked}
                                onChange={(checked) => this.setState({isChecked: checked})}
                            />
                            <div className='text'>
                                Я подтверждаю свое согласие на обработку
                                и хранение персональных данных
                            </div>
                        </div>
                        <div className='buttons row'>
                            <Button type='accent' size='large' fullWidth onClick={() => this.sendCall()}
                                    disabled={!this.state.isChecked}>
                                Записаться на приём
                            </Button>
                        </div>
                    </div>
                </ModalComponent>
            </div>
        </div>
    }
}


export default withRouter(MainLayout);
